import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region META

function _Meta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Meta = withLabelTokenParsing(_Meta, Token.TypeParsing.artist);
const Tokens = () => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
        Token.getWrappedTokenConfig('Birthdate', Token.Artist.Birthdate),
        Token.getWrappedTokenConfig('Deathdate', Token.Artist.Deathdate),
        Token.getWrappedTokenConfig('Biography', Token.Artist.Biography),
        Token.getWrappedTokenConfig('Curriculum Vitae', Token.Artist.CurriculumVitae)
    ]
}
const TypeConfig = {
    defaultDesign: `${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}`,
    panel: {
        block: () => LabelValueTypeConfig.panel.block(1),
        description: LabelValueTypeConfig.panel.description,
        label: LabelValueTypeConfig.panel.label,
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(TypeConfig.defaultDesign)
    }
};

// #endregion META

export {
    Meta as Component,
    Tokens,
    TypeConfig
}